import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink, AlertTriangle } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { Button } from '../components/ui/Button';
export function HelpShopifyPage() {
  return <div className="min-h-screen bg-gray-50" dir="rtl" data-id="element-2068">
      <Navbar data-id="element-2069" />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-2070">
        <Link to="/configure" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6" data-id="element-2071">
          <ArrowRight className="ml-2 w-4 h-4" data-id="element-2072" />
          رجوع إلى الإعدادات
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-2073">
          <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-green-50 to-emerald-50" data-id="element-2074">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2075">
              كيفية ربط Shopify
            </h1>
            <p className="text-gray-600" data-id="element-2076">
              اتبع الخطوات التالية للحصول على Admin API Access Token من متجر
              Shopify
            </p>
          </div>

          <div className="p-8 space-y-8" data-id="element-2077">
            {/* Warning */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 flex items-start gap-3" data-id="element-2078">
              <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-2079" />
              <div className="text-sm text-yellow-800" data-id="element-2080">
                <strong data-id="element-2081">تحذير أمني:</strong> لا تشارك Admin API Access Token مع
                أي شخص. احتفظ به في مكان آمن.
              </div>
            </div>

            {/* Steps */}
            <div className="space-y-6" data-id="element-2082">
              <div className="flex gap-4" data-id="element-2083">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-2084">
                  1
                </div>
                <div className="flex-1" data-id="element-2085">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2086">
                    افتح Shopify Admin
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2087">
                    سجل دخولك إلى لوحة تحكم Shopify الخاصة بمتجرك
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2088">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2089">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-2090">
                  2
                </div>
                <div className="flex-1" data-id="element-2091">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2092">
                    اذهب إلى Apps and sales channels
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2093">
                    من القائمة الجانبية، اختر "Settings" → "Apps and sales
                    channels"
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2094">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2095">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-2096">
                  3
                </div>
                <div className="flex-1" data-id="element-2097">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2098">
                    أنشئ Custom App
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2099">
                    اضغط على "Develop apps" → "Create an app" → أدخل اسم التطبيق
                    (مثلاً: Operiens Integration)
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2100">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2101">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-2102">
                  4
                </div>
                <div className="flex-1" data-id="element-2103">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2104">
                    اضبط الصلاحيات (Scopes)
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2105">
                    اذهب إلى "Configure Admin API scopes" واختر الصلاحيات
                    المطلوبة:
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-1 mb-3" data-id="element-2106">
                    <li data-id="element-2107">read_products, write_products</li>
                    <li data-id="element-2108">read_orders, write_orders</li>
                    <li data-id="element-2109">read_customers, write_customers</li>
                  </ul>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2110">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2111">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-2112">
                  5
                </div>
                <div className="flex-1" data-id="element-2113">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2114">
                    احصل على Admin API Access Token
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2115">
                    اضغط على "Install app" → انسخ "Admin API access token"
                    والصقه في صفحة الإعدادات
                  </p>
                  <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700 mb-3" data-id="element-2116">
                    ⚠️ هذا الـ Token سيظهر مرة واحدة فقط. احفظه في مكان آمن.
                  </div>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2117">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>
            </div>

            {/* Video Tutorial */}
            <div className="border-t border-gray-100 pt-8" data-id="element-2118">
              <h3 className="font-bold text-gray-900 mb-4" data-id="element-2119">شرح بالفيديو</h3>
              <div className="bg-gray-100 rounded-lg aspect-video flex items-center justify-center text-gray-500" data-id="element-2120">
                [فيديو يوتيوب - سيتم إضافته]
              </div>
            </div>

            {/* CTA */}
            <div className="border-t border-gray-100 pt-8" data-id="element-2121">
              <Link to="/configure" data-id="element-2122">
                <Button size="lg" fullWidth data-id="element-2123">
                  رجوع إلى الإعدادات
                  <ArrowRight className="mr-2 w-5 h-5" data-id="element-2124" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>;
}